<aipb-loading [loading]="loading$ | async">
  <pc-message-list
    [compact]="true"
    [lang]="lang$ | async"
    [messages]="messages$ | async"
    class="flex-auto overflow-auto"
  ></pc-message-list>
</aipb-loading>
